export default "__VITE_ASSET__ee3cc6a9__"